import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import {
  BaseComponent,
  required,
  noSpecialChar,
  email,
  number,
  alphaNumeric,
  phoneNumber,
  maxLength,
  minLength,
  minValue,
  maxValue,
  trim,
} from "BaseComponent";
import {
  fetchTemplatesWizardStep,
  saveTemplatesWizardData,
} from "../../actions";
import { validateEmail } from "Constants";

class Overview extends BaseComponent {
  constructor(props) {
    super(props);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = { loading: false };
  }

  onSubmitForm(values) {
    // this.setState({ loading: true });

    if (values.title) {
      values.title = values.title.trim();
    }
    if (values.metadescription) {
      values.metadescription = values.metadescription.trim();
    }

    let data = {
      resource: {
        overview: values,
        url: undefined,
        theme: undefined,
        publish: undefined,
      },
    };

    this.props.saveTemplatesWizardData(data);

    // ------- An alternate version of this.props.saveTemplatesWizardData() -------
    // this.props.saveTemplatesWizardData(data, (res) => {
    //     // if(res.success){

    //     // }
    // });

    // ===================== !!! IMPORTANT to know !!! =====================
    //This very next console statement was not showing updated data
    //But delay of 1 milisecond showing the updated data
    setTimeout(() => {
      this.props.fetchTemplatesWizardStep("step_2");
    }, 1);
    //===============================================================
  }

  renderFieldText(field) {
    var labelposition = field.labelposition;
    var formdiv = "";
    if (field.formdiv !== undefined && field.formdiv === "false") {
      formdiv = "";
    }
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0";
    var noteClasses = "col-sm-12 col-sm-offset-0 text-muted-custom";

    return (
      <div className={divClassName}>
        <label className={labelClasses} style={{ color: "#767988" }}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>

        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
            max={field.max ? field.max : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>

        <div className={noteClasses}>
          <p>{field.note}</p>
        </div>
      </div>
    );
  }

  renderFieldTextarea(field) {
    var labelposition = field.labelposition;
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;
    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0";
    var noteClasses = "col-sm-12 col-sm-offset-0 text-muted-custom";

    return (
      <div className={divClassName}>
        <label className={labelClasses} style={{ color: "#767988" }}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>

        <div className={inputClasses}>
          <textarea
            className="form-control"
            placeholder={field.placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ""}
          ></textarea>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>

        <div className={noteClasses}>
          <p>{field.note}</p>
        </div>
      </div>
    );
  }

  renderFieldCheckbox(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;

    return (
      <div className={divClassName}>
        <label
          className="custom-container-checkbox"
          style={{ marginBottom: 5, color: "#767988", fontWeight: "bold" }}
        >
          {field.label}
          <input type={field.type} {...field.input} />
          <span className="checkmark" />
        </label>
      </div>
    );
  }

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      editMode,
      initialValues,
      TemplatesWizardStep,
      TemplatesWizardData,
    } = this.props;

    return (
      <div style={{ width: "70%" }}>
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <div className="row">
            <div className="col-md-12">
              <label className="setting-company-section-heading">
                {" "}
                Provide basic details for your website
              </label>
              {/* <hr></hr> */}

              <div
                className="col-md-12"
                style={{
                  border: "solid 1px #A9ABB5",
                  borderRadius: 10,
                  padding: 15,
                }}
              >
                <Field
                  name="title"
                  label={"Title"}
                  placeholder={"ex: techshow2019"}
                  note={"Title cannot have special characters"}
                  type="text"
                  mandatory="true"
                  component={this.renderFieldText}
                  validate={[required, noSpecialChar]}
                  // format={trim}
                />

                <Field
                  name="metakeywords"
                  label={"Meta Keywords"}
                  placeholder={"Add meta keywords for your website"}
                  note={
                    "Add comma separated values ex: business,techevent,technology"
                  }
                  type="text"
                  component={this.renderFieldText}
                  normalize={trim}
                />

                <Field
                  name="metadescription"
                  label={"Meta Description"}
                  placeholder={"Type meta description"}
                  component={this.renderFieldTextarea}
                />

                {/* this extra col-md-12 div is given for an UI issue of checkbox */}
                {/* <div className="col-md-12" style={{ marginTop: 15 }}>
                                    <Field
                                        name="getemail"
                                        label="Do you want to get email when you receive any contact query?"
                                        component={this.renderFieldCheckbox}
                                        type="checkbox"
                                    />
                                </div> */}

                <div className="col-md-12 text-center">
                  <Button
                    className="btn-custom-blue mt-70 mb-10"
                    loading={this.state.loading}
                    disabled={pristine || invalid || submitting}
                    type="submit"
                  >
                    Start Deploying
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};
  var title = values["title"];
  var metakeywords = values["metakeywords"];
  var metadescription = values["metadescription"];
  var getemail = values["getemail"];

  // if (!title || title.trim() === '') {
  //     errors['title'] = "Title is required";
  // }

  // if (!metakeywords || metakeywords.trim() === '') {
  //     errors['metakeywords'] = "Meta Keywords is required";
  // }

  // if (!metadescription || metadescription.trim() === '') {
  //     errors['metadescription'] = "Meta description is required";
  // }

  // if (!email || email.trim() === '') {
  //     errors['email'] = 'Email is required';
  // }
  // else if (email && !validateEmail(email)) {
  //     errors['email'] = "Invalid email id";
  // }

  return errors;
}

function mapStateToProps(state) {
  var initVals = null;
  var toEdit = false;

  // if (state.SettingData && state.SettingData.resource && state.SettingData.resource.length > 0) {
  //     initVals = state.SettingData.resource[0];
  //     if (state.SettingData.resource[0].tax == '0') {
  //         initVals.tax = '';
  //     }
  //     toEdit = true;
  // }

  if (
    state.TemplatesWizardData &&
    state.TemplatesWizardData.resource &&
    state.TemplatesWizardData.resource.overview &&
    !_.isEmpty(state.TemplatesWizardData.resource.overview)
  ) {
    initVals = state.TemplatesWizardData.resource.overview;
    toEdit = true;
  }

  return {
    session: state.session,
    initialValues: initVals,
    editMode: toEdit,
    TemplatesWizardStep: state.TemplatesWizardStep,
    TemplatesWizardData: state.TemplatesWizardData,

    siteDetails: state.siteDetails,
    redeploy: state.redeploy,
  };
}

export default connect(mapStateToProps, {
  fetchTemplatesWizardStep,
  saveTemplatesWizardData,
})(
  reduxForm({
    validate,
    form: "TemplatesWizardOverviewForm",
    enableReinitialize: true,
    // keepDirtyOnReinitialize: true
  })(Overview)
);
